import Tableau from "th/tableau";

export { Tableau };

customElements.define("th-tableau", Tableau.CustomElementConstructor);
